import { Grid, Typography, withStyles } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom/cjs/react-router-dom'

import styles from '../../../resources/theme/global'
import colors from '../../../assets/colors'
import { renderRoute } from '../../../util/utils'

import Filter from './Filter'
import List from './List'
import EditClient from './Edit'

const ClientPlans = props => {
  const permissions = useSelector(state => state.auth.permissions)

  const { classes } = props

  return (
    <Grid container spacing={2} className={classes.pageHead}>
      <Grid item xs={12}>
        <Typography
          variant="h4"
          style={{ fontSize: '20px', color: colors.primary }}
        >
          Planos
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Filter />
      </Grid>

      <Grid item xs={12}>
        <List classes={classes} />
      </Grid>

      {renderRoute(['client-plan-edit'], permissions) && (
        <Route path="/client-plan/:id/edit" component={EditClient} />
      )}
    </Grid>
  )
}

export default withStyles(styles)(ClientPlans)
